<template>
  <material-card
    :title="`${ $t('Shifts') }`"
    data-testId="material-card-Shifts"
    color="dover-blue">
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        py-0
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          wrap>
          <v-flex
            sm12
            xs12
            md12
            lg12
            text-xs-center>
            <span>
              {{ $t('Select closing shifts and day configuration') }}
            </span>
            <hr>
          </v-flex>
          <v-flex
            sm6
            xs6
            md3
            lg3>
            <MaglinkComponentShiftList
              v-if="checkDayRendering(0)"
              :shift-number="1"
              :initial-value="workDay[0]"
              :is-valid-shift="rules.isValidDay[0]"
              :text="$t('End of Day')"
              data-testId="MaglinkComponentShiftList-End-of-Day"
              @onShiftSelection="onWorkDaySelection" />
          </v-flex>
          <v-flex
            sm6
            xs6
            md9
            lg9
          />
          <v-flex
            v-for="index in 4"
            :key="index"
            sm6
            xs6
            md3
            lg3>
            <MaglinkComponentShiftList
              v-if="checkRendering(index - 1)"
              :shift-number="index"
              :initial-value="shifts[index - 1]"
              :is-valid-shift="rules.isValidShift[index - 1]"
              data-testId="MaglinkComponentShiftList"
              @onShiftSelection="onShiftSelection" />
          </v-flex>
          <v-flex
            xs12
            sm12
            text-xs-center>
            <v-btn
              :disabled="!isValidationOk || !Maglink.IsAdminUser()"
              data-testId="btn-Save-shift-schedule"
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="onSaveShiftSchedule">
              {{ $t('Save shift schedule') }}
            </v-btn>
            <br>
            <hr>
            <br>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-form
      ref="site"
      v-model="isSiteValidationOk"
      lazy-validation>
      <v-container
        py-0
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          wrap>
          <v-flex
            sm12
            xs12
            md12
            lg12
            text-xs-center>
            <br>
            <span>
              {{ $t('Open/Close site') }}
            </span>
            <hr>
          </v-flex>
          <v-flex
            v-for="day in days"
            :key="day.key"
            sm3
            xs4
            md2
            lg2
            xl1>
            <v-checkbox
              v-model="selectedDays"
              :label="day.label"
              :value="day.key"
              data-testId="checkbox-day-label" />
          </v-flex>
          <v-flex
            sm12
            xs12
            md12
            lg12 />
          <v-flex
            sm6
            xs6
            md3
            lg3>
            <MaglinkComponentShiftList
              v-if="checkSiteRendering(0)"
              :shift-number="1"
              :initial-value="times[0]"
              :is-valid-shift="rules.isValidSite[0]"
              :text="$t('Open')"
              data-testId="MaglinkComponentShiftList-Open"
              @onShiftSelection="onOpenCloseSelection" />
          </v-flex>
          <v-flex
            sm6
            xs6
            md3
            lg3>
            <MaglinkComponentShiftList
              v-if="checkSiteRendering(1)"
              :shift-number="2"
              :initial-value="times[1]"
              :is-valid-shift="rules.isValidSite[1]"
              :text="$t('Close')"
              data-testId="MaglinkComponentShiftList-Close"
              @onShiftSelection="onOpenCloseSelection" />
          </v-flex>
          <v-flex
            sm12
            xs12
            md6
            lg6>
            <v-switch
              v-model="siteOpen"
              :label="$t('Site Open')"
              data-testId="switch-Site-Open"
              class="dover-input"/>
          </v-flex>

          <v-flex
            xs12
            sm12
            text-xs-center>
            <v-btn
              :disabled="!isSiteValidationOk || !Maglink.IsAdminUser()"
              data-testId="btn-Save-Open"
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="onSaveOpenCloseSite">
              {{ $t('Save Open/Close Site') }}
            </v-btn>
            <br>
            <hr>
            <br>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>

export default {
  data: () => ({
    isValidationOk: false,
    rules: {
      isValidDay: [[v => true]],
      isValidShift: [ [ v => true ], [ v => true ], [ v => true ], [ v => true ] ],
      isValidSite: [ [ v => true ], [ v => true ], [ v => true ], [ v => true ] ]
    },
    workDay: [],
    shifts: [],
    shiftDb: {},
    systemSettings: {},
    isSiteValidationOk: false,
    selectedDays: [],
    days: [],
    times: [],
    openCloseDb: {},
    siteOpen: false
  }),
  mounted () {
    this.Maglink.GetSettings('SystemSettings')
      .then(response => (this.systemSettings = { ...this.systemSettings, ...response.data }))
      .catch(error => (this.snack('error', error.message)))

    this.Maglink.GetShifts()
      .then(response => {
        this.shiftDb = response.data
        this.shifts = []

        this.dbToDisplay(this.shiftDb.shift1, 0)
        this.dbToDisplay(this.shiftDb.shift2, 1)
        this.dbToDisplay(this.shiftDb.shift3, 2)
        this.dbToDisplay(this.shiftDb.shift4, 3)

        this.dayToDisplay(this.shiftDb.endOfDay, 0)
      })
      .catch(error => (this.snack('error', error.message)))

    this.days = []
    this.days.push({ 'key': '2', 'label': this.$t('Monday') })
    this.days.push({ 'key': '4', 'label': this.$t('Tuesday') })
    this.days.push({ 'key': '8', 'label': this.$t('Wednesday') })
    this.days.push({ 'key': '16', 'label': this.$t('Thursday') })
    this.days.push({ 'key': '32', 'label': this.$t('Friday') })
    this.days.push({ 'key': '64', 'label': this.$t('Saturday') })
    this.days.push({ 'key': '1', 'label': this.$t('Sunday') })

    this.Maglink.GetOpenClose()
      .then(response => {
        this.openCloseDb = response.data
        this.times = []

        this.siteDbToDisplay(this.openCloseDb.openTime, 0)
        this.siteDbToDisplay(this.openCloseDb.closeTime, 1)
        this.siteOpen = this.openCloseDb.siteOpen === 1

        this.selectedDays = []
        this.days.forEach(day => {
          if (this.openCloseDb.daysOfWeek & day.key) {
            this.selectedDays.push(day.key)
          }
        })
      })
      .catch(error => (this.snack('error', error.message)))
  },
  methods: {
    dayToDisplay (value, index) {
      if (value < 0) {
        this.workDay[index] = { code: -1, desc: this.$t('None') }
      } else {
        let hour = Math.floor(value / 60)
        let min = value % 60
        this.workDay[index] = { code: value, desc: ('00' + hour).slice(-2) + '.' + ('00' + min).slice(-2) }
      }
    },
    dbToDisplay (value, index) {
      if (value < 0) {
        this.shifts[index] = { code: -1, desc: this.$t('None') }
      } else {
        let hour = Math.floor(value / 60)
        let min = value % 60
        this.shifts[index] = { code: value, desc: ('00' + hour).slice(-2) + '.' + ('00' + min).slice(-2) }
      }
    },
    checkDayRendering (index) {
      return this.workDay[index] && this.rules.isValidDay[index]
    },
    checkRendering (index) {
      return this.shifts[index] && this.rules.isValidShift[index]
    },
    onWorkDaySelection (number, data) {
      // must make a clone
      this.workDay[number - 1].code = data.code
      this.workDay[number - 1].desc = data.desc
      this.isValidationOk = true
    },
    onShiftSelection (shiftNumber, shift) {
      // must make a clone
      this.shifts[shiftNumber - 1].code = shift.code
      this.shifts[shiftNumber - 1].desc = shift.desc
      this.isValidationOk = true
      let newRules = []
      for (let index = 0; index < 4; index++) {
        // initialize
        newRules[index] = [ v => true ]
      }

      for (let index = 1; index < 4; index++) {
        // compare values
        let s1 = this.shifts[index - 1]
        let s2 = this.shifts[index]

        // no selection
        if (s1.code === -1) continue
        if (s2.code === -1) continue

        if (s1.code >= s2.code) {
          this.isValidationOk = false
          newRules[index - 1] = [ this.$t('Values must be sequential') ]
          newRules[index] = [ this.$t('Values must be sequential') ]
        }
      }

      this.rules.isValidShift = newRules
    },
    onSaveShiftSchedule () {
      this.shiftDb.shift1 = this.shifts[0].code
      this.shiftDb.shift2 = this.shifts[1].code
      this.shiftDb.shift3 = this.shifts[2].code
      this.shiftDb.shift4 = this.shifts[3].code
      this.shiftDb.endOfDay = this.workDay[0].code

      this.Maglink.SaveShifts(this.shiftDb)
        .then(response => {
          this.snack('success', this.$t('Shifts saved successfully'))
        })
        .catch(error => {
          this.snack('error', error.message)
        })
    },

    checkSiteRendering (index) {
      return this.times[index] && this.rules.isValidSite[index]
    },
    siteDbToDisplay (value, index) {
      if (value < 0) {
        this.times[index] = { code: -1, desc: this.$t('None') }
      } else {
        let hour = Math.floor(value / 60)
        let min = value % 60
        this.times[index] = { code: value, desc: ('00' + hour).slice(-2) + '.' + ('00' + min).slice(-2) }
      }
    },
    onOpenCloseSelection (shiftNumber, shift) {
      // must make a clone
      this.times[shiftNumber - 1].code = shift.code
      this.times[shiftNumber - 1].desc = shift.desc
      this.isSiteValidationOk = true
      let newRules = []
      for (let index = 0; index < 2; index++) {
        // initialize
        newRules[index] = [ v => true ]
      }

      for (let index = 1; index < 2; index++) {
        // compare values
        let s1 = this.times[index - 1]
        let s2 = this.times[index]

        // no selection
        if (s1.code === -1) continue
        if (s2.code === -1) continue

        if (s1.code >= s2.code) {
          this.isSiteValidationOk = false
          newRules[index - 1] = [ this.$t('Values must be sequential') ]
          newRules[index] = [ this.$t('Values must be sequential') ]
        }
      }

      this.rules.isValidSite = newRules
    },
    onSaveOpenCloseSite () {
      this.openCloseDb.openTime = this.times[0].code
      this.openCloseDb.closeTime = this.times[1].code
      this.openCloseDb.siteOpen = (this.siteOpen ? 1 : 0)

      this.openCloseDb.daysOfWeek = 0
      this.selectedDays.forEach(day => {
        this.openCloseDb.daysOfWeek += parseInt(day)
      })

      this.Maglink.SaveOpenClose(this.openCloseDb)
        .then(response => {
          this.snack('success', this.$t('Open/Close settings saved successfully'))
        })
        .catch(error => {
          this.snack('error', error.message)
        })
    },

    snack (color, message) {
      message = this.$t('Shifts') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
